import React from 'react'
import { Box } from '@mui/material'
import { DEFAULT_DARK_MESSAGE_TEXT_COLOR } from '../../../../../common/constants/themeConstants'
import './htmlEditor.css'

export default function HtmlPreview({ data, isCurrentThemeLight }) {
  const htmlContent = data?.data || '<p>No HTML content available</p>'
  const styles = getStyles(isCurrentThemeLight)

  return (
    <Box sx={styles.container}>
      <Box sx={styles.content}>
        <div
          className='preview-container'
          data-theme={isCurrentThemeLight ? 'light' : 'dark'}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
          style={{
            color: isCurrentThemeLight ? DEFAULT_DARK_MESSAGE_TEXT_COLOR : 'rgba(255, 255, 255, 0.9)',
            fontFamily: 'Plus Jakarta Sans',
            lineHeight: '1.6',
            backgroundColor: 'transparent' // Remove background for clean preview
          }}
        />
      </Box>
    </Box>
  )
}

const getStyles = isCurrentThemeLight => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '24px'
  },
  content: {
    flex: 1,
    padding: '20px',
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '12px',
    overflow: 'auto',
    minHeight: '400px',
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px'
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '10px',
      background: isCurrentThemeLight ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0.3)',
      transition: 'background 0.2s ease'
    },
    scrollbarWidth: 'thin',
    scrollbarColor: isCurrentThemeLight
      ? 'rgba(0, 0, 0, 0.2) rgba(255, 255, 255, 0.1)'
      : 'rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1)'
  }
})
